import { render } from "./CancerOverallSurvival.vue?vue&type=template&id=4d4e41c1&scoped=true"
import script from "./CancerOverallSurvival.vue?vue&type=script&lang=js"
export * from "./CancerOverallSurvival.vue?vue&type=script&lang=js"

import "./CancerOverallSurvival.vue?vue&type=style&index=0&id=4d4e41c1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d4e41c1"]])

export default __exports__